import React, { useRef, useState } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import { useScreen } from '../../styles';
import { TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
import { customSearch, isIOS } from '../../utils';
import { get, last, noop } from '../../lib/lodash';

const TradeMarker = styled('div', {
  shouldForwardProp: (prop) => prop !== 'topOffset',
})(({ topOffset }) => ({
  position: 'absolute',
  top: topOffset,
  left: 0,
}));

const StyledAutocompleteInput = styled(TextField)(({ theme }) => ({
  zIndex: 201,
  '& .MuiInputBase-root': {
    lineHeight: '1.5',
    fontSize: '0.875rem',
    fontWeight: '250',
    letterSpacing: '0.02857em',
    paddingLeft: theme.spacing(1),
  },
}));

const Overlay = styled('div')({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.25)',
  zIndex: 200,
});

export const AutoComplete = React.forwardRef((props, ref) => {
  const [autoFocus, setAutoFocus] = useState(props.autoFocus);
  const controlRef = useRef();
  const { isMobileXS } = useScreen();
  const [isIos] = useState(isIOS());
  const topOffset = get(props, 'topOffset', -50) - (isIos ? 20 : 0);

  const setElementStyle = (query, stl = []) => {
    try {
      const elem = last(document.querySelectorAll(query));
      stl.map((s) => {
        elem.style[s.key] = s.value;
      });
    } catch (err) {
      console.error(err);
    }
  };

  const onOpen = () => {
    try {
      props.onOpen && props.onOpen();

      if (isMobileXS) {
        setElementStyle('.formScrollContainer', [{ key: 'overflow', value: 'visible' }]);

        setTimeout(() => {
          try {
            controlRef.current.scrollIntoView({
              behaviour: 'smooth',
              block: 'start',
            });
          } catch (err) {
            console.error(err);
          }
        }, 700);
      }
    } catch (err) {}
  };

  const onToggleClose = () => {
    if (isMobileXS) {
      setElementStyle('.formScrollContainer', [{ key: 'overflow', value: 'auto' }]);

      if (!autoFocus) {
        setAutoFocus(true);
      } else {
        props.onClose && props.onClose();
      }
    } else {
      props.onClose && props.onClose();
    }
  };

  const onClose = () => {
    props.onClose && props.onClose();
    if (isMobileXS) {
      setElementStyle('.formScrollContainer', [{ key: 'overflow', value: 'auto' }]);
    }
  };

  const filterOptions = (opts, s) => {
    let ret = customSearch(opts, s, {}, false);
    if (props.alwaysInclude) {
      ret = [...ret, ...props.alwaysInclude]
    }
    return ret;
  }

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <TradeMarker ref={controlRef} topOffset={topOffset} className="tradeMarker" />
      {props.open && <Overlay onClick={onClose} />}
      <Autocomplete
        renderInput={(params) => <StyledAutocompleteInput variant="standard" {...props} onChange={noop} {...params} />}
        filterOptions={filterOptions}
        {...props}
        ref={ref}
        onOpen={onOpen}
        onClose={onToggleClose}
      />
    </div>
  );
});
